import {Component, Input} from '@angular/core';
import {StatisticService} from "../../../services/statistic.service";
import {RoleService} from "../../../services/role.service";
import {Role} from "../../../dip/role";

@Component({
  selector: 'app-historical',
  templateUrl: './historical.component.html',
  styleUrls: ['./historical.component.scss']
})
export class HistoricalComponent {
  @Input() organization;
  data;
  dongleData;
  userData;
  carsTotalOption;
  carsRatioOption;
  activeDonglesOption;
  companyDonglesOptions = [];
  usersOption;
  isPhone: boolean = window.innerWidth <= 768;

  constructor(private statisticService: StatisticService, private roleService: RoleService) { }


  ngOnChanges() {
    this.getHistorical();
  }

  getHistorical() {
    const organization = this.organization;
    if (organization === undefined) return;
    this.statisticService.getHistorical(organization ? organization.id : null).subscribe(res => {
      if (res.success) {
        this.data = res.data;
        this.data.sort(this.compare);
        this.getActiveDongles(organization);
      }
    })
  }

  getActiveDongles(organization) {
    this.companyDonglesOptions = [];
    this.statisticService.getActiveDongles(organization ? organization.id : null).subscribe(res => {
      if (res.success) {
        this.dongleData = res.data;
        this.dongleData.activities.sort(this.compare);
        this.dongleData.organizationActivities.forEach(data => data.sort(this.compare));
        this.getUsersHistory(organization);
      }
    })
  }

  getUsersHistory(organization) {
    this.statisticService.getUsersHistory(organization ? organization.id : null).subscribe(res => {
      if (res.success) {
        this.userData = res.data;
        this.setData();
      }
    })
  }

  setData() {
    let carsTotalOption = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      xAxis: [
        {
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0,
            rotate: this.isPhone ? 90 : 0
          },
          axisTick: {
            show: false
          }
        }
      ],
      yAxis: [{
        type: 'value',
        minInterval: 1
      }],
      grid: {
        left: '100%',
        right: '100%',
        containLabel: true
      },
      series: [
        {
          name: 'Alert',
          type: 'bar',
          stack: 'stack',
          data: [],
          color: ['#ad0606']
        },
        {
          name: 'Warning',
          type: 'bar',
          stack: 'stack',
          data: [],
          color: ['#ffd904']
        },
        {
          name: 'OK',
          type: 'bar',
          stack: 'stack',
          data: [],
          color: ['#0d8f25']
        },
        {
          name: 'Inactive',
          type: 'bar',
          stack: 'stack',
          data: [],
          color: ['#616161']
        },
        {
          name: 'Unknown',
          type: 'bar',
          stack: 'stack',
          data: [],
          color: ['#BDBDBD']
        },
      ],
    }
    carsTotalOption.xAxis[0].data = this.data.map(d => this.getLabel(d.dueDate));
    const carsTotalMonths = carsTotalOption.xAxis[0].data.length;
    let monthCounter = this.data[0].dueDate;
    for (let i = 0; i < 24-carsTotalMonths; i++) {
      monthCounter--;
      if (monthCounter.toString().slice(-2) == '00') monthCounter = monthCounter-88;
      carsTotalOption.xAxis[0].data.unshift(this.getLabel(monthCounter, i+1 === 24-carsTotalMonths));
      carsTotalOption.series[0].data.push(0);
      carsTotalOption.series[1].data.push(0);
      carsTotalOption.series[2].data.push(0);
      carsTotalOption.series[3].data.push(0);
      carsTotalOption.series[4].data.push(0);
    }
    this.data.forEach(data => {
      carsTotalOption.series[0].data.push(data.alerted);
      carsTotalOption.series[1].data.push(data.warned);
      carsTotalOption.series[2].data.push(data.ok);
      carsTotalOption.series[3].data.push(data.inactive);
      carsTotalOption.series[4].data.push(data.unknown);
    })
    this.carsTotalOption = carsTotalOption;


    let carsRatioOption = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      xAxis: [
        {
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0,
            rotate: this.isPhone ? 90 : 0
          },
          axisTick: {
            show: false
          }
        }
      ],
      yAxis: [{
        type: 'value',
        minInterval: 1
      }],
      grid: {
        left: '100%',
        right: '100%',
        containLabel: true
      },
      series: [
        {
          name: 'Alert',
          type: 'bar',
          stack: 'stack',
          data: [],
          color: ['#ad0606']
        },
        {
          name: 'Warning',
          type: 'bar',
          stack: 'stack',
          data: [],
          color: ['#ffd904']
        },
        {
          name: 'OK',
          type: 'bar',
          stack: 'stack',
          data: [],
          color: ['#0d8f25']
        },
        {
          name: 'Inactive',
          type: 'bar',
          stack: 'stack',
          data: [],
          color: ['#616161']
        },
        {
          name: 'Unknown',
          type: 'bar',
          stack: 'stack',
          data: [],
          color: ['#BDBDBD']
        },
      ],
    }
    carsRatioOption.xAxis[0].data = this.data.map(d => this.getLabel(d.dueDate));
    const carsRatioMonths = carsRatioOption.xAxis[0].data.length;
    monthCounter = this.data[0].dueDate;
    for (let i = 0; i < 24-carsRatioMonths; i++) {
      monthCounter--;
      if (monthCounter.toString().slice(-2) == '00') monthCounter = monthCounter-88;
      carsRatioOption.xAxis[0].data.unshift(this.getLabel(monthCounter, i+1 === 24-carsRatioMonths));
      carsRatioOption.series[0].data.push(0);
      carsRatioOption.series[1].data.push(0);
      carsRatioOption.series[2].data.push(0);
      carsRatioOption.series[3].data.push(0);
      carsRatioOption.series[4].data.push(0);
    }
    this.data.forEach(data => {
      carsRatioOption.series[0].data.push(+(data.alerted*100/data.all).toFixed(2));
      carsRatioOption.series[1].data.push(+(data.warned*100/data.all).toFixed(2));
      carsRatioOption.series[2].data.push(+(data.ok*100/data.all).toFixed(2));
      carsRatioOption.series[3].data.push(+(data.inactive*100/data.all).toFixed(2));
      carsRatioOption.series[4].data.push(+(data.unknown*100/data.all).toFixed(2));
    })
    this.carsRatioOption = carsRatioOption;


    let activeDonglesOption = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      xAxis: [
        {
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0,
            rotate: this.isPhone ? 90 : 0
          },
          axisTick: {
            show: false
          }
        }
      ],
      yAxis: [{
        type: 'value',
        minInterval: 1
      }],
      grid: {
        left: '100%',
        right: '100%',
        containLabel: true
      },
      series: [
        {
          name: 'Active dongles',
          type: 'bar',
          data: [],
        },
      ],
    }
    activeDonglesOption.xAxis[0].data = this.dongleData.activities.map(d => this.getLabel(d.dueDate));
    const activeDonglesMothsCount = activeDonglesOption.xAxis[0].data.length;
    monthCounter = this.dongleData.activities[0].dueDate;
    for (let i = 0; i < 24-activeDonglesMothsCount; i++) {
      monthCounter--;
      if (monthCounter.toString().slice(-2) == '00') monthCounter = monthCounter-88;
      activeDonglesOption.xAxis[0].data.unshift(this.getLabel(monthCounter, i+1 === 24-activeDonglesMothsCount));
      activeDonglesOption.series[0].data.push(0);
    }
    this.dongleData.activities.forEach(data => {
      activeDonglesOption.series[0].data.push(data.count);
    })
    this.activeDonglesOption = activeDonglesOption;

    let usersOption = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      xAxis: [
        {
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0,
            rotate: this.isPhone ? 90 : 0
          },
          axisTick: {
            show: false
          }
        }
      ],
      yAxis: [{
        type: 'value',
        minInterval: 1
      }],
      grid: {
        left: '100%',
        right: '100%',
        containLabel: true
      },
      series: [
        {
          name: 'Inactive',
          type: 'bar',
          stack: 'stack',
          data: [],
          color: ['#ad0606']
        },
        {
          name: 'Active',
          type: 'bar',
          stack: 'stack',
          data: [],
          color: ['#0d8f25']
        }
      ],
    }
    usersOption.xAxis[0].data = this.userData.map(d => this.getLabel(d.dueDate));
    const usersMothsCount = usersOption.xAxis[0].data.length;
    monthCounter = this.userData[0].dueDate;
    for (let i = 0; i < 24-usersMothsCount; i++) {
      monthCounter--;
      if (monthCounter.toString().slice(-2) == '00') monthCounter = monthCounter-88;
      usersOption.xAxis[0].data.unshift(this.getLabel(monthCounter, i+1 === 24-usersMothsCount));
      usersOption.series[0].data.push(0);
      usersOption.series[1].data.push(0);
    }
    this.userData.forEach(data => {
      usersOption.series[0].data.push(data.allCount-data.loggedInCount);
      usersOption.series[1].data.push(data.loggedInCount);
    })
    this.usersOption = usersOption;

    if (this.showCompanyDongles) {
      this.dongleData.organizationActivities.forEach(company => {
        let companyDongleOption = {
          title: {
            text: company[0].name
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          xAxis: [
            {
              type: 'category',
              data: [],
              axisLabel: {
                interval: 0,
                rotate: this.isPhone ? 90 : 0
              },
              axisTick: {
                show: false
              }
            }
          ],
          yAxis: [{
            type: 'value',
            minInterval: 1
          }],
          grid: {
            left: '100%',
            right: '100%',
            containLabel: true
          },
          series: [
            {
              name: 'Active dongles',
              type: 'bar',
              data: [],
            },
          ],
        }
        companyDongleOption.xAxis[0].data = company.map(c => this.getLabel(c.dueDate));
        const companyDongleMothsCount = companyDongleOption.xAxis[0].data.length;
        monthCounter = company[0].dueDate;
        for (let i = 0; i < 24-companyDongleMothsCount; i++) {
          monthCounter--;
          if (monthCounter.toString().slice(-2) == '00') monthCounter = monthCounter-88;
          companyDongleOption.xAxis[0].data.unshift(this.getLabel(monthCounter, i+1 === 24-companyDongleMothsCount));
          companyDongleOption.series[0].data.push(0);
        }
        company.forEach(data => {
          companyDongleOption.series[0].data.push(data.count);
        })
        this.companyDonglesOptions.push(companyDongleOption);
      })
    }
  }

  getLabel(date: number, showYear: boolean = false) {
    const month = date.toString().slice(4);
    const year = date.toString().slice(0,4);
    let label = '';

    switch (month) {
      case '01': {
        label= this.isPhone ? year + ' Jan' : 'Jan\n' + year
        break;
      }
      case '02': {
        label='Feb'
        break;
      }
      case '03': {
        label='Mar'
        break;
      }
      case '04': {
        label='Apr'
        break;
      }
      case '05': {
        label='May'
        break;
      }
      case '06': {
        label='Jun'
        break;
      }
      case '07': {
        label='Jul'
        break;
      }
      case '08': {
        label='Aug'
        break;
      }
      case '09': {
        label='Sep'
        break;
      }
      case '10': {
        label='Oct'
        break;
      }
      case '11': {
        label='Nov'
        break;
      }
      case '12': {
        label='Dec'
        break;
      }
    }
    if (showYear && month !== '01') label = this.isPhone ? year + ' ' + label : label + '\n' + year;
    return label;

  }

  showCompanyDongles() {
    if (!this.roleService.hasRole([Role.ROLE_SYS, Role.ROLE_DISTRIBUTOR])) return false;
    return this.organization ? this.organization.organizationType.id !== 2 : true;
  }

  compare( a, b ) {
    if ( a.dueDate < b.dueDate ){
      return -1;
    }
    if ( a.dueDate > b.dueDate ){
      return 1;
    }
    return 0;
  }
}
